<script>
import StyleBox from "../StyleBox.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import LPTemp1 from "../templates/lastPages/LPTemp1.vue";
import LPTemp2 from "../templates/lastPages/LPTemp2.vue";
import LPTemp3 from "../templates/lastPages/LPTemp3.vue";
import LPTemp4 from "../templates/lastPages/LPTemp4.vue";
import LPTemp5 from "../templates/lastPages/LPTemp5.vue";
import LPTemp6 from "../templates/lastPages/LPTemp6.vue";
import LPTemp7 from "../templates/lastPages/LPTemp7.vue";
import SelectDropdown from "../SelectDropdown.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import { isLastPageReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/LPTemp1.png";
import img2 from "@/assets/images/templates/LPTemp2.png";
import img3 from "@/assets/images/templates/LPTemp3.png";
import img4 from "@/assets/images/templates/LPTemp4.png";
import img5 from "@/assets/images/templates/LPTemp5.png";
import img6 from "@/assets/images/templates/LPTemp6.png";
import img7 from "@/assets/images/templates/LPTemp7.png";

export default {
    name: "StepLastPage",
    components: {
        LPTemp1, LPTemp2, LPTemp3, LPTemp4, LPTemp5, LPTemp6, LPTemp7,
        StyleBox,
        ColorSchemeBox,
        SelectDropdown,
        ProjectsDropdown,
        PreviewTemplates,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            TemplateList: [
                {
                    label: '1- Display proposal details with company logo',
                    value: 1,
                    preview: img1,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(1)
                },
                {
                    label: '2- Display proposal details and company name as text with 1 project as background',
                    value: 2,
                    preview: img2,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(2)
                },
                {
                    label: '3- Display proposal details with company logo and 2 projects in vertical layout',
                    value: 3,
                    preview: img3,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(3)
                },
                {
                    label: '4- Display proposal details and company logo on gradient banner with project as background',
                    value: 4,
                    preview: img4,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(4)
                },
                {
                    label: '5- Display proposal details with company logo and 1 project in three rows layout',
                    value: 5,
                    preview: img5,
                    orientation: 'portrait',
                    style: this.getTemplateStyle(5)
                },
                {
                    label: '1- Full page landscape image with company info at bottom center',
                    value: 6,
                    preview: img6,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(6)
                },
                {
                    label: '2- Full page landscape image with company info on left dark sidebar',
                    value: 7,
                    preview: img7,
                    orientation: 'landscape',
                    style: this.getTemplateStyle(7)
                }
            ]
        };
    },
    computed: {
        isPreviewable() {
            return isLastPageReady(this.proposal.lastPage);
        }
    },
    methods: {
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: t == 7 ? "#000000" : "#001b3c",
                    body: t == 5 ? "#e3e3e4" : "#001b3c",
                    footer: t == 7 ? "#e3e3e4" : "#001b3c",
                },
                heading: {
                    color: "#ffffff",
                    size: "72",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: "#ffffff",
                    size: t == 5 || t == 6 ? "16" : t == 7 ? "24" : "18",
                    font: "Arial",
                    bold: t == 6 || t == 7 ? true : false,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: "#ffffff",
                    size: t == 5 || t == 6 ? "16" : "18",
                    font: "Arial",
                    bold: t == 6 ? true : false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling() {
            const match = this.TemplateList.find(item => item.value === this.proposal.lastPage.template);
            if (match) this.proposal.lastPage.style = match.style;
        },
        handleTemplateSelection(selectedTemplate) {
            this.proposal.lastPage.template = selectedTemplate;
            if (selectedTemplate === 1) {
                this.proposal.lastPage.projects = [];
            }
            if (selectedTemplate === 2 || selectedTemplate === 4 || selectedTemplate === 5 || selectedTemplate === 6 || selectedTemplate === 7) {
                this.proposal.lastPage.projects = this.proposal.lastPage.projects.slice(0, 1);
            }
            this.fixStyling();
        },
        handleProjectSelection(selectedNames) {
            this.proposal.lastPage.projects = selectedNames;
        }
    }
};
</script>


<template>
  <div class="d-flex flex-column gap-3 w-100 bg-white mb-3 rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Last Page</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <SelectDropdown label="Template" :modelValue="proposal.lastPage.template"
            :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
            placeholder="Select Template" @update:modelValue="handleTemplateSelection" :isPreviewable="true" />
        </div>
      </div>

      <div class="row">
        <div v-if="proposal.lastPage.template && proposal.lastPage.template !== 1" class="col-12 col-md-6 mb-3">
          <ProjectsDropdown label="Projects" :modelValue="proposal.lastPage.projects"
            @update:modelValue="handleProjectSelection"
            :disabled="!proposal.lastPage.template || proposal.lastPage.template === 1"
            :max-selection="[2, 4, 5, 6, 7].includes(proposal.lastPage.template) ? 1 : 2"
            :multi="[2, 4, 5, 6, 7].includes(proposal.lastPage.template) ? false : true" />
        </div>
      </div>

      <div class="row" v-if="proposal.lastPage.style">
        <div v-for="item in [
          { key: 'colorScheme', label: 'Color Scheme' },
          { key: 'heading', label: 'Heading Color', disabled: !proposal.lastPage.template || proposal.lastPage.template !== 2 },
          { key: 'label', label: 'Label Color' },
          { key: 'text', label: 'Text Color' }
        ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
          <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="proposal.lastPage.style[item.key]"
            :label="item.label" />
          <StyleBox v-else :styling="proposal.lastPage.style[item.key]" :label="item.label" :disabled="item.disabled" />
        </div>
      </div>
    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" emptyMessage="Select template to preview">
      <LPTemp1 v-if="proposal.lastPage.template === 1" :proposal="proposal.lastPage" />
      <LPTemp2 v-if="proposal.lastPage.template === 2" :proposal="proposal.lastPage" />
      <LPTemp3 v-if="proposal.lastPage.template === 3" :proposal="proposal.lastPage" />
      <LPTemp4 v-if="proposal.lastPage.template === 4" :proposal="proposal.lastPage" />
      <LPTemp5 v-if="proposal.lastPage.template === 5" :proposal="proposal.lastPage" />
      <LPTemp6 v-if="proposal.lastPage.template === 6" :proposal="proposal.lastPage" />
      <LPTemp7 v-if="proposal.lastPage.template === 7" :proposal="proposal.lastPage" />
    </PreviewTemplates>
  </div>
</template>